module.exports = __webpack_public_path__ + "static/assets/ce5820b006d753e4133f46ae776f4d96.svg";